package one.healthium.update_food_preferences.domain.models

data class FoodPreferenceOption(
    val id: String,
    val status: FoodPreferenceStatus,
)
